export const ENDPOINT_SITE_MOTION_SETTINGS_READ = '/site/settings/motionget/';
export const ENDPOINT_SITE_MOTION_SETTINGS_READ_LOCKS = '/site/locks/getmotionsettings/'
export const ENDPOINT_SITE_MOTION_SETTINGS_UPDATE = '/site/settings/motionset/';
